/**
 * AppLayout — Main application layout with sidebar, topbar, and content outlet.
 * Responsive: sidebar as drawer on mobile, fixed on desktop.
 * F9 update: TopBar now manages its own notification center internally.
 * issue_167: Pass onOpenSidebar to MobileNav so the "Altro" button can open the drawer.
 */

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { MobileNav } from './MobileNav';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Sidebar (desktop fixed, mobile drawer) */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main area */}
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar onMenuClick={() => setSidebarOpen(true)} />

        {/* Page content — wrapped in ErrorBoundary to prevent full-app crash */}
        <main className="flex-1 pb-20 lg:pb-0 p-[5px]">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>

        {/* Mobile bottom nav */}
        <MobileNav onOpenSidebar={() => setSidebarOpen(true)} />
      </div>
    </div>
  );
}

export default AppLayout;